import * as THREE from "three";

// Shared Viewer conversion, originally introduced by d08dbcf3 (FBX Support).
export const setTextureColorSpace = (texture, colorSpace) => {
    if (!texture) {
        return;
    }
    if (texture.colorSpace !== undefined) {
        texture.colorSpace = colorSpace;
    } else if (texture.encoding !== undefined && colorSpace === THREE.SRGBColorSpace) {
        texture.encoding = THREE.sRGBEncoding;
    }
};

export const convertFbxMaterial = (material, node) => {
    if (!material) {
        return material;
    }

    if (material.isMeshStandardMaterial || material.isMeshPhysicalMaterial) {
        setTextureColorSpace(material.map, THREE.SRGBColorSpace);
        setTextureColorSpace(material.emissiveMap, THREE.SRGBColorSpace);
        return material;
    }

    if (material.isMeshBasicMaterial) {
        setTextureColorSpace(material.map, THREE.SRGBColorSpace);
        setTextureColorSpace(material.emissiveMap, THREE.SRGBColorSpace);
        return material;
    }

    if (!material.isMeshPhongMaterial && !material.isMeshLambertMaterial) {
        return material;
    }

    const converted = new THREE.MeshStandardMaterial();
    converted.name = material.name;
    converted.userData = { ...material.userData };
    if (material.color && converted.color) {
        converted.color.copy(material.color);
    }
    converted.opacity = material.opacity ?? 1;
    converted.transparent =
        material.transparent ?? (Number.isFinite(converted.opacity) && converted.opacity < 1);
    converted.side = material.side ?? THREE.FrontSide;
    converted.flatShading = material.flatShading ?? false;
    if ("wireframe" in material) {
        converted.wireframe = material.wireframe;
    }

    if (material.map) {
        converted.map = material.map;
        setTextureColorSpace(converted.map, THREE.SRGBColorSpace);
    }
    if (material.emissive && converted.emissive) {
        converted.emissive.copy(material.emissive);
    }
    if (material.emissiveMap) {
        converted.emissiveMap = material.emissiveMap;
        setTextureColorSpace(converted.emissiveMap, THREE.SRGBColorSpace);
    }
    if (material.emissiveIntensity !== undefined) {
        converted.emissiveIntensity = material.emissiveIntensity;
    }

    if (material.normalMap) {
        converted.normalMap = material.normalMap;
        if (material.normalScale && converted.normalScale) {
            converted.normalScale.copy(material.normalScale);
        }
    }
    if (material.bumpMap) {
        converted.bumpMap = material.bumpMap;
        converted.bumpScale = material.bumpScale ?? 1;
    }
    if (material.aoMap) {
        converted.aoMap = material.aoMap;
        converted.aoMapIntensity = material.aoMapIntensity ?? 1;
    }
    if (material.alphaMap) {
        converted.alphaMap = material.alphaMap;
    }

    const shininess = material.shininess;
    if (Number.isFinite(shininess)) {
        const normalized = Math.min(Math.max(shininess / 100, 0), 1);
        converted.roughness = 1 - normalized;
    } else {
        converted.roughness = 0.6;
    }
    converted.metalness = 0.0;

    if (node?.isSkinnedMesh) {
        converted.skinning = true;
    }
    if ("morphTargets" in converted && node?.morphTargetInfluences) {
        converted.morphTargets = true;
        if ("morphNormals" in converted) {
            converted.morphNormals = true;
        }
    }

    return converted;
};

